<template>
	<div class="form-group">
		<template v-if="required">
			<label class="form-label">Password <span class="text-danger">*</span></label>
			<input type="password" class="form-control" :name="name" v-model="inputData" :placeholder="'Enter Password'" v-validate="'required'">
			<small class="d-block text-danger">{{ errors.first(name) }}</small>
		</template>
		<template v-else>
			<label class="form-label">Password</label>
			<input type="password" class="form-control" :name="name" v-model="inputData" :placeholder="'Enter Password'">
		</template>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'Password',
	inject: ['$validator'],
	props: {
		data: String,
		name: String,
		required: Boolean
	},
	data() {
		return {
			inputData: ""
		}
	},
	mounted() {
		this.$root.$on('reset-validation', () => {
			// Reset Vee Validate
			this.$validator.reset();
		});
	},
	methods: {
		
	},
	watch: {
		inputData: {
			handler: function() {
				this.$emit('update:value', this.inputData)
			},
			deep: true
		},
		data: function() {
			this.inputData = this.data;
		}
	}
}
</script>